const testSoundUrlWebm = 'https://d133zon9jtcf53.cloudfront.net/audio/sound_check_audio_clip.webm';
const testSoundUrlMp3 = 'https://d133zon9jtcf53.cloudfront.net/audio/sound_check_audio_clip.mp3';

const startLiveSessionError = {
    MISSING_SESSION: 'missingSession',
    DEFAULT: 'default',
};

const SHOW_RECORDER_STREAMING_FAILED_MESSAGE_TIMEOUT = 10; // seconds

export {
    SHOW_RECORDER_STREAMING_FAILED_MESSAGE_TIMEOUT,
    startLiveSessionError,
    testSoundUrlMp3,
    testSoundUrlWebm,
};
